import * as studentTestsTypes from "Store/students/studentsTests/constants";
import {
  HANDLE_FETCH_STUDENT_TEST_REPORT_LINK,
  IHandleFetchStudentTestReportLink, ISetStudentTestReportLink
} from "Store/students/studentsTests/constants";

// @TODO: to be typed

export const setStudentTests = (payload: Test[]): studentTestsTypes.ISetStudentTests => ({
  type: studentTestsTypes.SET_STUDENT_TESTS,
  payload
});

export const setActiveTestScores = (
  payload: TestScores
): studentTestsTypes.ISetActiveTestScores => ({
  type: studentTestsTypes.SET_ACTIVE_TEST_SCORES,
  payload
});

export const setActiveStudentTest = (payload: Test): studentTestsTypes.ISetActiveStudentTest => ({
  type: studentTestsTypes.SET_ACTIVE_STUDENT_TEST,
  payload
});

export const setEssayScore = (payload: EssayRequest): studentTestsTypes.ISetEsssayScore => ({
  type: studentTestsTypes.SET_ESSAY_SCORE,
  payload
});

export const handleUpdateEssayScore = (
  payload: EssayRequest
): studentTestsTypes.IHandleUpdateEssayScore => ({
  type: studentTestsTypes.HANDLE_UPDATE_ESSAY_SCORE,
  payload
});

export const updateTestFlagCount = (
  payload: UpdateStudentTestFlagsCountPayload
): studentTestsTypes.ISetStudentTestFlagCount => ({
  type: studentTestsTypes.SET_STUDENT_TEST_FLAG_COUNT,
  payload
});

export const handleMarkTestAllFlagsReviewed = (
  payload
): studentTestsTypes.IHandleMarkTestAllFlagsReviewed => ({
  type: studentTestsTypes.HANDLE_MARK_TEST_ALL_FLAGS_REVIEWED,
  payload
});

export const handleAssignStudentTest = (
  payload: Partial<NewTestRequest>,
  source: Source = "list"
): studentTestsTypes.IHandleAssignStudentTest => ({
  type: studentTestsTypes.HANDLE_ASSIGN_STUDENT_TEST,
  payload,
  source
});

export const handleFetchStudentTestSections = (
    payload: StudentTestSectionPayload
): studentTestsTypes.IHandleFetchStudentTestSections => ({
  type: studentTestsTypes.HANDLE_FETCH_STUDENT_TEST_SECTIONS,
  payload
});

export const handleFetchStudentTestReportLink = (
    payload: StudentTestSectionPayload
): studentTestsTypes.IHandleFetchStudentTestReportLink => ({
  type: studentTestsTypes.HANDLE_FETCH_STUDENT_TEST_REPORT_LINK,
  payload
});

export const handleFetchStudentTestReport = (
    payload: StudentTestReport
): studentTestsTypes.IHandleFetchStudentTestReport => ({
  type: studentTestsTypes.HANDLE_FETCH_STUDENT_TEST_REPORT,
  payload
});

export const handleStudentTestSectionManagement = (
  payload: TestSectionPayload
): studentTestsTypes.IHandleStudentTestSectionManagement => ({
  type: studentTestsTypes.HANDLE_STUDENT_TEST_SECTION_MANAGEMENT,
  payload
});

export const handleExcuseStudentTestLateness = (
  payload: UpdateTestLatenessObject[]
): studentTestsTypes.IHandleExcuseStudentTestLateness => ({
  type: studentTestsTypes.HANDLE_EXCUSE_STUDENT_TEST_LATENESS,
  payload
});

export const handleFetchStudentTests = (): studentTestsTypes.IHandleFetchStudentTests => ({
  type: studentTestsTypes.HANDLE_FETCH_STUDENT_TESTS
});

export const handleFetchAllStudentTests = (): studentTestsTypes.IHandleFetchAllStudentTests => ({
  type: studentTestsTypes.HANDLE_FETCH_ALL_STUDENT_TESTS
});

export const handleResetStudentTests = (
  payload: string[]
): studentTestsTypes.IHandleResetStudentTest => ({
  type: studentTestsTypes.HANDLE_RESET_STUDENT_TESTS,
  payload
});

export const handleCreateStudentRealTest = (
  payload: StudentRealTestRequest
): studentTestsTypes.IHandleCreateStudentRealTest => ({
  type: studentTestsTypes.HANDLE_CREATE_STUDENT_REAL_TEST,
  payload
});

export const setStudentTestSections = (
    payload: Section[]
): studentTestsTypes.ISetStudentTestSections => ({
  type: studentTestsTypes.SET_STUDENT_TEST_SECTIONS,
  payload
});

export const setStudentTestReportLink = (
    payload: StudentTestReportLink
): studentTestsTypes.ISetStudentTestReportLink => ({
  type: studentTestsTypes.SET_STUDENT_TEST_REPORT_LINK,
  payload
});

export const setStudentTestReportData = (
    payload: StudentTestReportData
): studentTestsTypes.ISetStudentTestReportData => ({
  type: studentTestsTypes.SET_STUDENT_TEST_REPORT_DATA,
  payload
});

// export const handleUpdateStudentRealTest = (
//   payload: RealTestEditRequest,
//   changes: TestChangesRequest
// ): studentTestsTypes.IHandleUpdateStudentRealTest => ({
//   type: studentTestsTypes.HANDLE_UPDATE_STUDENT_REAL_TEST,
//   payload,
//   changes
// });

export const handleRescheduleStudentTest = (
  payload: RescheduleStudentTestRequest
): studentTestsTypes.IHandleRescheduleStudentTest => ({
  type: studentTestsTypes.HANDLE_RESCHEDULE_STUDENT_TEST,
  payload
});

export const handleUpdateStudentTest = (
  payload: UpdateTestPayload,
  testChanges?: TestChangesRequest
): studentTestsTypes.IUpdateStudentTest => ({
  type: studentTestsTypes.UPDATE_STUDENT_TEST,
  payload,
  testChanges
});

export const handleAddStudentTestProblemFlag = (
  payload: AddStudentTestFlagPayload
): studentTestsTypes.IHandleAddStudentTestProblemFlag => ({
  type: studentTestsTypes.HANDLE_ADD_STUDENT_TEST_PROBLEM_FLAG,
  payload
});

export const handleUpdateStudentTestProblemFlagStatus = (
  payload: UpdateStudentTestFlagPayload
): studentTestsTypes.IHandleUpdateStudentTestProblemFlagStatus => ({
  type: studentTestsTypes.HANDLE_UPDATE_STUDENT_TEST_PROBLEM_FLAG_STATUS,
  payload
});

export const setStudentTestProblemFlagStatus = (
  payload: UpdateStudentTestProblemFlagPayload
): studentTestsTypes.ISetStudentTestProblemFlagStatus => ({
  type: studentTestsTypes.SET_STUDENT_TEST_PROBLEM_FLAG_STATUS,
  payload
});

export const handleFetchStudentScoredTests =
  (): studentTestsTypes.IHandleFetchStudentScoredTests => ({
    type: studentTestsTypes.HANDLE_FETCH_STUDENT_SCORED_TESTS
  });

export const setStudentScoredTests = (
  payload: ScoredTest[]
): studentTestsTypes.ISetStudentScoredTests => ({
  type: studentTestsTypes.SET_STUDENT_SCORED_TESTS,
  payload
});

export const fetchStudentReportPDF = (
  payload: StudentTestReportPDFRequest,
  isPartial: boolean = false,
  preview: boolean = false
): studentTestsTypes.IHandleFetchPartialStudentTestReportPDF => ({
  type: studentTestsTypes.FETCH_STUDENT_REPORT_PDF,
  payload,
  isPartial,
  preview
});

export const setStudentTestPreviewPDF = (
  payload: Blob
): studentTestsTypes.ISetStudentTestPreviewPDF => ({
  type: studentTestsTypes.SET_STUDENT_TEST_PREVIEW_PDF,
  payload
});

export const handleFetchTribyteTestSection = (
  test: Test
): studentTestsTypes.IHandleFEtchTribyteTestSection => ({
  type: studentTestsTypes.HANDLE_FETCH_TRIBYTE_TEST_SECTION,
  payload: {
    test
  }
});

export const setTribyteTestSectionUrl = (
  url: string,
  sectionId: string
): studentTestsTypes.ISetTribyteTestSectionUrl => ({
  type: studentTestsTypes.SET_TRIBYTE_TEST_SECTION_URL,
  payload: { url, sectionId }
});
